import React, { useContext, useEffect, useState, useRef } from "react";
import UserContext from "../../contexts/UserContext";
import Utils from "../../Utils";
import _ from "lodash";
import axios from "axios";

const PhHeader = (props) => {
  const { logout, userData } = useContext(UserContext);
  const [open, setOpen] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClick(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    }

    function handleKey(e) {
      if (e.key === "Escape") setOpen(false);
    }

    document.addEventListener("mousedown", handleClick);
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("keydown", handleKey);
    };
  }, []);

  useEffect(() => {
    axios
      .get(Utils.apiUrl(`notifications?mode=count`), Utils.apiHeaders())
      .then((res) => {
        setNotificationCount(res.data.total);
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  }, []);

  return (
    <>
      <header className="bg-white shadow-md py-4 px-8 flex justify-between items-center header">
        <div className="flex items-center gap-8">
          <img
            src={`${process.env.PUBLIC_URL}/images/logo.png`}
            alt="Marriott Bonvoy"
            className="logo"
          />
          <span className="flex items-center gap-2">
            <div className="w-6 h-6 rounded-full bg-blue-600 text-white flex items-center justify-center text-xs font-bold shrink-0">
              PG
            </div>
            <h3 className="text-lg font-semibold text-gray-700">
              Photographer Panel
            </h3>
          </span>
        </div>
        <nav>
          <ul className="flex space-x-6 font-bold">
            {notificationCount > 0 && (
              <li>
                <div
                  className="text-yellow-400 hover:text-yellow-700 flex cursor-pointer"
                  title="Click to view the notifications"
                >
                  <i className="fas fa-bell mr-1 text-xl"></i>
                  <span className="absolute top-3 mx-3 border border-gray-400 text-gray-500 rounded-full w-6 h-6 flex items-center justify-center text-xs shadow-md">
                    {notificationCount > 99 ? "99+" : notificationCount}
                  </span>
                </div>
              </li>
            )}
            <li>
              <a
                href={`${process.env.PUBLIC_URL}/photographer-dashboard`}
                className="text-gray-600 hover:text-blue-500"
              >
                Dashboard
              </a>
            </li>
            <li>
              <a
                href={`${process.env.PUBLIC_URL}/resources`}
                className="text-gray-600 hover:text-blue-500"
              >
                Photography Resource Hub
              </a>
            </li>
            <li>
              <a
                href={`${process.env.PUBLIC_URL}/photographer-manage-photoshoots`}
                className="text-gray-600 hover:text-blue-500"
              >
                Photoshoots
              </a>
            </li>
            <li className="relative" ref={dropdownRef}>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setOpen(!open);
                }}
                className="flex items-center text-gray-600 hover:text-blue-500 focus:outline-none font-bold"
                style={{ cursor: "pointer" }}
              >
                <span className="mr-2">{userData?.name || "User"}</span>
                <i
                  className={`fas ${open ? "fa-angle-down" : "fa-angle-right"} ml-1`}
                ></i>
              </button>

              {open && (
                <div className="absolute right-0 mt-2 w-44 bg-white border rounded shadow-md z-50">
                  <a
                    href={process.env.PUBLIC_URL + "/change-password"}
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    Change Password
                  </a>
                  <button
                    onClick={logout}
                    className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    Logout
                  </button>
                </div>
              )}
            </li>
          </ul>
        </nav>
      </header>
    </>
  );
};

export default PhHeader;
